import {strTrim as trim} from '@/utils/string'

export const strTrim = (value, chars, isRegexp = true) => {
	return trim(value, chars, isRegexp)
}